import React from "react";
import { InputBar, IconButton } from "../../../components";
import { decrypt, cryptoActions } from "../store/CryptoReducer";
import { useAppDispatch, useAppSelector } from "../../../store";

export const DecryptBar = () => {
  const dispatch = useAppDispatch();
  const selected = useAppSelector((state) => state.crypto.selected);
  const key = useAppSelector((state) => state.crypto.key);
  const disableDecrypt = !key || !selected;
  const disabledPick = false;

  const handlePick = () => {
    if (!disabledPick) {
    }
  };
  const handleDecrypt = () => {
    if (!disableDecrypt && key) {
      dispatch(cryptoActions.setSelected(decrypt(selected, key)));
    }
  };

  return (
    <InputBar
      placeholder="Nachricht des Partners"
      innerLeft={
        <IconButton
          onPress={handlePick}
          disabled={disabledPick}
          icon="PickMsg"
        />
      }
      innerRight={
        <IconButton
          onPress={handleDecrypt}
          disabled={disableDecrypt}
          icon="Decrypt"
        />
      }
      onChangeText={(text) => dispatch(cryptoActions.setSelected(text))}
      value={selected}
      onSubmitEditing={handleDecrypt}
    />
  );
};
